import 'slick-carousel';

export default function proofsSliders() {
  const $slider = $('.js-proofs-slider');

  $slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 901,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  });
}
